export default __webpack_public_path__ + "static/media/caret-down.a152271c.svg";